import { render, staticRenderFns } from "./guidePanel.vue?vue&type=template&id=db52a124&scoped=true&"
import script from "./guidePanel.vue?vue&type=script&lang=js&"
export * from "./guidePanel.vue?vue&type=script&lang=js&"
import style0 from "./guidePanel.vue?vue&type=style&index=0&id=db52a124&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52a124",
  null
  
)

export default component.exports